// MARK: NPM Modules
import React from "react";
// MARK: Types
import Images from "types/media/image";
import Videos from "types/media/video";
import OnlineVideos from "types/media/onlineVideos";
// MARK: Components
import Image from "components/common/media/image";
import Video from "components/common/media/autoPlayLoopingVideo";
import OnlineVideo from "components/common/media/onlineVideo";
import Hero from "types/fields/entries/hero";

// MARK: React Component
// Props
interface MediaProps {
  hero: Hero;
  borderradius?: number;
}
// Component
const Media = ({ hero, borderradius }: MediaProps) => {
  if (hero.length === 0) {
    return <Image src={""} alt={""} borderradius={borderradius} />;
  }
  var item;
  const media = hero[0];

  switch (media.sectionHandle) {
    case "videos":
      item = media as Videos;
      const videoAltText = item.altText.replace("<p>", "").replace("</p>", "")
      //poster={item.poster[0].url} < removed as it makes the carousel wonky.
      // In the lack of a poster, it uses the first frame (which is the poster we had).
      return (
        <Video
          src={item.videoAsset[0].url}
          poster={item.poster}
          borderradius={borderradius}
          altText={videoAltText}
        />
      );
    case "onlineVideos":
      item = media as OnlineVideos;
      switch (item.typeHandle) {
        case "youtube":
          return (
            <OnlineVideo
              title="youtube"
              src={
                "https://www.youtube.com/embed/" + item.onlineVideoIdentifier
              }
            />
          );
        default:
          return (
            <OnlineVideo
              title="vimeo"
              src={
                "https://player.vimeo.com/video/" + item.onlineVideoIdentifier
              }
            />
          );
      }
    default:
      item = media as Images;
      const altText = item.altText.replace("<p>", "").replace("</p>", "")
      return (
        <Image
          src={item.imageAsset[0].url}
          alt={altText}
          borderradius={borderradius}
          loading="lazy"
        />
      );
      break;
  }
};

export default Media;
